import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import { Editor, EditorContent, BubbleMenu } from "@tiptap/vue-2";
import { generateHTML } from '@tiptap/html';
import Document from '@tiptap/extension-document';
import Text from '@tiptap/extension-text';
import Image from '@tiptap/extension-image';
import ResizableImage from "../../assets/js/tiptap-customs/ResizableImage";
import Bold from '@tiptap/extension-bold';
import TextAlign from '@tiptap/extension-text-align';
import ListItem from '@tiptap/extension-list-item';
import Italic from '@tiptap/extension-italic';
import Underline from '@tiptap/extension-underline';
import Strike from '@tiptap/extension-strike';
import CustomPlaceholder from "../../assets/js/tiptap-customs/CustomPlaceholder";
import Direction from "../../assets/js/tiptap-customs/Direction";
import Color from "../../assets/js/tiptap-customs/Color";
import TextStyle from '@tiptap/extension-text-style';
import CustomParagraph from "../../assets/js/tiptap-customs/CustomParagraph";
import CustomBulletList from "../../assets/js/tiptap-customs/CustomBulletList";
import { isString as isVString } from "../../assets/js/mcn-helpers";
import MultimediaDialog from "./MultimediaDialog";
import CustomOrderedList from "../../assets/js/tiptap-customs/CustomOrderedList";
import History from '@tiptap/extension-history';
import FontSize from 'tiptap-extension-font-size';
import Link from '@tiptap/extension-link';
import { v4 } from 'uuid';
export default {
  name: "TipTapEditor",
  components: {
    MultimediaDialog,
    EditorContent,
    BubbleMenu
  },
  props: {
    data: {
      type: Object
    },
    value: {
      type: String,
      default: ''
    },
    config: {
      type: Object
    },
    primaryColor: {},
    blockBackgroundColor: {}
  },
  data() {
    return {
      imageInputId: ['tip-tap-image-upload-input', v4()].join('-'),
      imageData: {
        multimediaType: 'image'
      },
      LibraryModal: false,
      color: null,
      colorPicker: false,
      editor: null,
      user_extensions: [],
      // errors of when an input has a wrong input (e.g. selecting video when image is expected)
      inputAlert: {
        open: false,
        type: 'error',
        messages: []
      },
      fontSizeList: [8, 9, 10, 11, 12, 14, 16, 18, 20, 26, 28]
    };
  },
  computed: {
    editorPlaceholderColor() {
      var _ref, _this$blockBackground;
      return (_ref = (_this$blockBackground = this.blockBackgroundColor) !== null && _this$blockBackground !== void 0 ? _this$blockBackground : this.primaryColor) !== null && _ref !== void 0 ? _ref : 'white';
    },
    isDirty() {
      return this.data.isDirty;
    },
    borderColor() {
      return this.hasError ? 'var(--v-error-base)' : this.isDirty ? this.$vuetify.theme.currentTheme.warning : this.$vuetify.theme.dark ? 'rgba(255, 255, 255, .3)' : 'rgba(0, 0, 0, .4)';
    },
    inputAlertType() {
      return this.inputAlert.type;
    },
    selectedFontSize() {
      var _this$fontSizeList$fi;
      return (_this$fontSizeList$fi = this.fontSizeList.find(fontSize => this.editor.isActive('textStyle', {
        fontSize: fontSize + 'pt'
      }))) !== null && _this$fontSizeList$fi !== void 0 ? _this$fontSizeList$fi : 16;
    },
    inputAlertMessage() {
      return this.inputAlert.messages[0];
    },
    showButton() {
      var _this$editor;
      return ((_this$editor = this.editor) === null || _this$editor === void 0 || (_this$editor = _this$editor.state) === null || _this$editor === void 0 || (_this$editor = _this$editor.selection) === null || _this$editor === void 0 || (_this$editor = _this$editor.node) === null || _this$editor === void 0 || (_this$editor = _this$editor.type) === null || _this$editor === void 0 ? void 0 : _this$editor.name) === 'ResizableImage';
    },
    isDraggable() {
      var _this$editor2;
      return (_this$editor2 = this.editor) === null || _this$editor2 === void 0 || (_this$editor2 = _this$editor2.state) === null || _this$editor2 === void 0 || (_this$editor2 = _this$editor2.selection) === null || _this$editor2 === void 0 || (_this$editor2 = _this$editor2.node) === null || _this$editor2 === void 0 || (_this$editor2 = _this$editor2.attrs) === null || _this$editor2 === void 0 ? void 0 : _this$editor2.isDraggable;
    },
    hasError() {
      var _this$data;
      return ((_this$data = this.data) === null || _this$data === void 0 || (_this$data = _this$data.messages) === null || _this$data === void 0 ? void 0 : _this$data.length) > 0;
    },
    getMessages() {
      var _this$data2;
      return (_this$data2 = this.data) === null || _this$data2 === void 0 || (_this$data2 = _this$data2.messages) === null || _this$data2 === void 0 ? void 0 : _this$data2[0];
    },
    placeholder() {
      return this.$t(this.data.placeholder);
    },
    colorIconColor() {
      return this.editor && isVString(this.editor.getAttributes('textStyle').color) ? this.editor.getAttributes('textStyle').color : '#6c757d';
    }
  },
  watch: {
    value(value) {
      let extensions = this.user_extensions.map(ae => ae.content).filter(e => e);
      let html = generateHTML(this.editor.getJSON(), extensions);
      const isSame = html === value;
      if (isSame) return;
      this.editor.commands.setContent(value, false);
    }
  },
  methods: {
    setInputAlertErrorMessages(messages) {
      this.setInputAlertMessages('error', messages);
    },
    setInputAlertSuccessMessages(messages) {
      this.setInputAlertMessages('success', messages);
    },
    setInputAlertMessages(type, messages) {
      this.inputAlert.open = true;
      this.inputAlert.type = type;
      this.inputAlert.messages = messages;
    },
    emptyInputAlertMessages() {
      this.inputAlert.messages = [];
    },
    setColor() {
      this.editor.chain().focus().setColor(this.color.hex).run();
    },
    undo() {
      this.editor.chain().focus().undo().run();
    },
    redo() {
      this.editor.chain().focus().redo().run();
    },
    addLink() {
      const previousUrl = this.editor.getAttributes('link').href;
      const url = window.prompt('URL', previousUrl);

      // cancelled
      if (url === null) {
        return;
      }

      // empty
      if (url === '') {
        this.editor.chain().focus().extendMarkRange('link').unsetLink().run();
        return;
      }

      // update link
      this.editor.chain().focus().extendMarkRange('link').setLink({
        href: url
      }).run();
    },
    addBullet() {
      this.editor.chain().focus().toggleBulletList().setDirection('auto').setTextAlign('justify').run();
    },
    addNumberedList() {
      this.editor.chain().focus().toggleOrderedList().setDirection('auto').setTextAlign('justify').run();
    },
    addRtlBullet() {
      this.editor.chain().focus().toggleBulletList().setDirection('rtl').setTextAlign('justify').run();
    },
    addRtlNumberedList() {
      this.editor.chain().focus().toggleOrderedList().setDirection('rtl').setTextAlign('justify').run();
    },
    setTextDirection(dir) {
      if (this.editor) this.editor.chain().focus().setTextAlign('justify').setDirection(this.isActive({
        dir
      }) ? 'auto' : dir).run();
    },
    setTextAlignment(alignment) {
      if (this.editor) this.editor.chain().focus().setDirection('auto').setTextAlign(this.isActive({
        textAlign: alignment
      }) ? 'justify' : alignment).run();
    },
    onImageReady(imageFile) {
      var _String$split;
      this.emptyInputAlertMessages();
      let image = imageFile.target.files[0];
      if (!(image instanceof File)) return;
      if (((_String$split = String(image.type).split('/')) === null || _String$split === void 0 ? void 0 : _String$split[0]) !== 'image') {
        this.setInputAlertErrorMessages(['Please select a valid image file.']);
        return;
      }
      let data = [{
        name: 'file',
        value: image
      }, {
        name: 'folder',
        value: this.data.folder
      }];
      // the padding around the editor
      let padding = 32;
      let editorMaxWidth = this.$refs.editorContent.$el.clientWidth - padding;
      const imageData = {
        src: null,
        isImageLoading: true,
        imageData: data,
        height: 200,
        editorMaxWidth
      };
      this.editor.chain().focus().setImage(imageData).run();
    },
    openUploadPanel() {
      let upload_input = document.createElement('input');
      upload_input.type = 'file';
      upload_input.click();
    },
    initValueProp() {
      let extensions = this.user_extensions.map(ae => ae.content).filter(e => e);
      let html = generateHTML(this.editor.getJSON(), extensions);
      if (html !== this.value) this.editor.commands.setContent(this.value, false);
    },
    showElement(name) {
      return this.user_extensions.some(ue => name === ue.name);
    },
    isActive(name) {
      return this.editor ? this.editor.isActive(name) : false;
    },
    addImage() {
      let imageInput = document.getElementById(this.imageInputId);
      if (imageInput) imageInput.click();
    },
    onFontSizeSelect(fontSize) {
      this.editor.chain().focus().setFontSize(fontSize + 'pt').run();
    }
  },
  mounted() {
    var _this$config;
    let bold = {
      name: 'bold',
      content: Bold
    };
    let link = {
      name: 'link',
      content: Link
    };
    let fontSize = {
      name: 'font-size',
      content: FontSize
    };
    let image = {
      name: 'image',
      content: Image
    };
    let history = {
      name: 'history',
      content: History
    };
    let resizable_image = {
      name: 'resizable_image',
      content: ResizableImage.configure({
        inline: true
      })
    };
    let align = {
      name: 'align',
      content: TextAlign.configure({
        types: ['paragraph', 'bulletList', 'image', 'ResizableImage']
      })
    };
    let bullet_list = {
      name: 'list-bulleted',
      content: CustomBulletList
    };
    //let bullet_list = {name: 'list-bulleted', content: MyBulletPoint}
    let ordered_list = {
      name: 'list-numbered',
      content: CustomOrderedList
    };
    let list_item = {
      name: 'list-numbered',
      content: ListItem
    };
    let italic = {
      name: 'italic',
      content: Italic
    };
    let underline = {
      name: 'underline',
      content: Underline
    };
    let strike = {
      name: 'strike',
      content: Strike
    };
    let color = {
      name: 'color',
      content: Color
    };
    let direction = {
      name: 'direction',
      content: Direction
    };

    // default extensions
    let placeholder = {
      name: 'paragraph',
      content: CustomPlaceholder.configure({
        placeholder: this.placeholder
      })
    };
    let document = {
      name: 'document',
      content: Document
    };
    let test_style = {
      name: 'textStyle',
      content: TextStyle
    };
    let custom_paragraph = {
      name: 'paragraph',
      content: CustomParagraph
    };
    let text = {
      name: 'text',
      content: Text
    };
    let bubble_menu = {
      name: 'bubble-menu',
      content: BubbleMenu
    };
    let necessary_extensions = [placeholder, document, custom_paragraph, text, test_style];
    let available_extensions = [bold, fontSize, history, image, resizable_image, align, bullet_list, ordered_list, list_item, italic, underline, strike, direction, color, link];
    let default_extensions = [bold, fontSize, history, align, bullet_list, ordered_list, list_item, direction, color];
    this.user_extensions = necessary_extensions.concat(Array.isArray((_this$config = this.config) === null || _this$config === void 0 ? void 0 : _this$config.elements) ? available_extensions.filter(ae => this.config.elements.includes(ae.name)) : default_extensions);
    this.editor = new Editor({
      content: this.value,
      extensions: this.user_extensions.map(ae => ae.content),
      editorProps: {
        transformPastedHTML(html) {
          // remove color and font-family from pasted html
          return html.replace(/(color|font-family)\s*[:=]\s*([^;"{}()<>]+)/ig, '');
        }
      },
      onUpdate: () => {
        let extensions = this.user_extensions.map(ae => ae.content).filter(e => e);
        let html = generateHTML(this.editor.getJSON(), extensions);
        // doing this will make image stop working again
        // let html = this.editor.getHTML()
        this.$emit('input', html);
        this.$emit('change', html);
      }
    });
  },
  beforeDestroy() {
    this.editor.destroy();
  }
};